import 'modernizr'; // eslint-disable-line
import '../bootstrap';

import Accessibility from '../modules/accessibility';
import tracking from '../modules/tracking';
import FormValidation from '../modules/formValidation';
import navigation from '../modules/navigation';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import cart from '../modules/cart';
import datepicker from '../modules/datepicker';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import videoElement from '../modules/videoElement';
import controlledInput from '../modules/controlledInput';
import discount from '../modules/discount';
import payment from '../modules/payment';
import data from '../modules/data';
import header from '../modules/header';
import companyHeader from '../modules/companyHeader';
import masonry from '../modules/masonry';
import mediaRow from '../modules/mediaRow';
import contactMap from '../modules/contactMap';
import mediaGrid from '../modules/mediaGrid';
import serviceModal from '../modules/serviceModal';
// insert-import

const general = () => {
  const app: any = {};

  tracking.initialize();
  app.accessibility = new Accessibility();
  app.formValidation = new FormValidation();
  toTop.initialize();
  videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  cart.initialize();
  datepicker.initialize();
  cookieBar.initialize();
  embedWrap();
  whatsapp.initialize();
  videoElement.initialize();
  controlledInput.initialize();
  discount.initialize();
  payment.initialize();
  data.initialize();
  navigation.initialize();
  header.initialize();
  companyHeader.initialize();
  masonry.initialize();
  mediaRow.initialize();
  contactMap.initialize();
  mediaGrid.initialize();
  serviceModal.initialize();
  // insert-definition

  if ($('.modal.auto-open').length) {
    $('.modal.auto-open').modal('show');
  }
};

export default general;
